(function ($) {
  const ITEM_SELECTOR = '.single-post__content .faq__item';
  const SLIDE_SPEED = 420;

  // <details> works without JS. This only adds the same sliding animation as the process accordion.
  function initFaq() {
    $(ITEM_SELECTOR).each(function () {
      const $item = $(this);
      const $summary = $item.children('summary').first();
      const $answer = $item.children('.faq__answer').first();

      if (!$summary.length || !$answer.length) {
        return;
      }

      $item.toggleClass('is-open', $item.prop('open'));

      $summary.on('click', function (event) {
        event.preventDefault();

        if ($item.hasClass('is-open')) {
          $item.removeClass('is-open');
          $answer.stop(true, true).slideUp(SLIDE_SPEED, function () {
            $item.removeAttr('open');
          });
          return;
        }

        $answer.stop(true, true).hide();
        $item.attr('open', '').addClass('is-open');
        $answer.slideDown(SLIDE_SPEED);
      });
    });
  }

  $(initFaq);
})(jQuery);
